import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  description: {
    width: '80%',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    marginY: '20px'
  } satisfies SxProps<Theme>
}
